var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.75478L10.4969 4.25789C10.8407 3.91404 11.3982 3.91404 11.7421 4.25789C12.086 4.60175 12.086 5.15926 11.7421 5.50311L9.24522 8L11.7421 10.4969C12.086 10.8407 12.086 11.3982 11.7421 11.7421C11.3982 12.086 10.8407 12.086 10.4969 11.7421L8 9.24522L5.50311 11.7421C5.15926 12.086 4.60175 12.086 4.25789 11.7421C3.91404 11.3982 3.91404 10.8407 4.25789 10.4969L6.75478 8L4.25789 5.50311C3.91404 5.15926 3.91404 4.60175 4.25789 4.25789C4.60175 3.91404 5.15926 3.91404 5.50311 4.25789L8 6.75478Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.e9520d814b548fd6527274154c44bef3.svg";
export { ForwardRef as ReactComponent };